import React from 'react';
import { FlameIcon, UsersIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function UrgencyBanner() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(24);
  return <section className="w-full border-y-[3px] border-dashed border-amber bg-danger px-6 py-12 text-center text-white sm:px-10" data-id="element-214" data-mp="2s9eodc802qly">
      <div className="mx-auto max-w-2xl" data-id="element-215" data-mp="2wbrtbyexakho">
        <p className="flex items-center justify-center gap-2 text-xl font-bold sm:text-2xl" data-id="element-216" data-mp="2waqj1w5qe210">
          <FlameIcon className="h-6 w-6" aria-hidden="true" data-id="element-217" data-mp="3188h2ri7mwu8" /> ¡Oferta por 24 horas solamente!
        </p>
        <p className="mt-4 text-xl font-bold text-amber sm:text-2xl" data-id="element-218" data-mp="369xs475fnaib">
          Antes: <span className="line-through" data-id="element-219" data-mp="3b6y2uvd891fr">€45</span> | Ahora: €17,99 (60% descuento)
        </p>

        <div className="mt-7 flex items-center justify-center gap-3 font-mono text-3xl font-bold sm:text-4xl" role="timer" aria-live="off" data-id="element-220" data-mp="1bwgfhf6kfy22">
          <div className="rounded-lg bg-white/10 px-4 py-2" data-id="element-221" data-mp="1gw2spome9eav">{hours}</div>
          <span aria-hidden="true" data-id="element-222" data-mp="27gau5f7egtkm">:</span>
          <div className="rounded-lg bg-white/10 px-4 py-2" data-id="element-223" data-mp="22o9my7p39t1g">{minutes}</div>
          <span aria-hidden="true" data-id="element-224" data-mp="22lwwt796gcdb">:</span>
          <div className="rounded-lg bg-white/10 px-4 py-2" data-id="element-225" data-mp="1xo55aecg2s9n">{seconds}</div>
        </div>
        <p className="mt-2 text-xs uppercase tracking-wide text-white/80" data-id="element-226" data-mp="1sqc09omvo4ay">Horas : Minutos : Segundos</p>

        <p className="mt-6 flex items-center justify-center gap-2 text-sm" data-id="element-227" data-mp="2qe3y8ktrf9jl">
          <span className="relative flex h-2 w-2" data-id="element-228" data-mp="2lehk8963xp9q">
            <span className="absolute inline-flex h-full w-full animate-pulse-dot rounded-full bg-amber" data-id="element-229" data-mp="2lfso08zjyx0u" />
          </span>
          <UsersIcon className="h-4 w-4" aria-hidden="true" data-id="element-230" data-mp="2ghhey0h30qjo" /> 47 personas mirando esto ahora
        </p>

        <a href="#comprar" onClick={trackInitiateCheckout} className="mt-7 inline-flex w-full items-center justify-center rounded-lg bg-amber px-8 py-5 text-lg font-bold text-danger transition-colors duration-150 ease-out hover:bg-amber-dark hover:text-white sm:w-auto sm:min-w-[420px]" data-id="element-231" data-mp="2cfvu9syb37yx">
          Quiero el método antiinflamatorio
        </a>
      </div>
    </section>;
}